import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PopoverController, IonicModule } from '@ionic/angular';
import { UserDataProvider } from '../../providers/user-data/user-data';
import { LocationServiceProvider } from '../../providers/location-service/location-service';
import { BeerServiceProvider } from '../../providers/beer-service/beer-service';
import { RequestUser, SearchVenueRequest, Venue } from '../../models/models';
import { VenueSelectionPopoverPage } from '../../pages/venue-selection-popover/venue-selection-popover';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage-angular';
import { SelectorPopoverPage } from '../../pages/selector-popover/selector-popover';
import { AppEventService } from '../../app/app-events';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * Generated class for the SortAndFilterBarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'sort-and-filter-bar',
  templateUrl: 'sort-and-filter-bar.html',
  styleUrls: ['./sort-and-filter-bar.scss'],
  standalone: false,
  // imports: [
  //   IonicModule,
  //   TranslateModule,
  //   CommonModule,
  //   FormsModule
  // ]
})
export class SortAndFilterBarComponent implements OnInit, OnDestroy {

  @Input()
  sortFilter: string;

  @Input()
  sortDirection: string;

  @Input()
  showMostRecent: string;

  // TODO hardcoded removal of "most_recent" in presentPopover
  private sortFilters = ["beer_name", "abv"];
  public showSortDirection: boolean = true;

  private itemSelectedSubsription: any;

  constructor(private events: AppEventService,
    private userData: UserDataProvider,
    private locationService: LocationServiceProvider,
    private beerService: BeerServiceProvider,
    public popoverCtrl: PopoverController,
    public translateService: TranslateService,
    private storage: Storage) {
    console.log('Hello SortAndFilterBarComponent Component');
  }

  ngOnInit() {
    console.log("sort-and-filter ngOnInit, showing most recent:", this.showMostRecent);
    if (this.showMostRecent == "true") {
      this.sortFilters.push("most_recent");
    }

    this.itemSelectedSubsription = (filter) => {
      this.sortFilter = filter;
      if (filter == "most_recent") {
        this.sortDirection = "DESC";
        this.showSortDirection = false;
      } else {
        this.showSortDirection = true;
      }
      this.sortingChanged();
    }
    this.events.subscribe("item:selected", this.itemSelectedSubsription);
  }

  ngOnDestroy() {
    this.events.unsubscribe("item:selected", this.itemSelectedSubsription)
  }

  sortingChanged() {
    console.log("sort-and-filter-bar - sortfilter changed to: ", this.sortFilter);

    let sortFilterObject = null;
    switch (this.sortFilter) {
      case "beer_name":
        sortFilterObject = {sortField: 'name', direction: this.sortDirection};
        break;
      case "abv":
        sortFilterObject = {sortField: 'abv', direction: this.sortDirection};
        break;
      case "rating":
        sortFilterObject = {sortField: 'totalexperience', direction: this.sortDirection};
        break;
      case "most_recent":
        sortFilterObject = {sortField: 'date', direction: this.sortDirection};
        break;
    }
    this.events.publish("sortfilter:changed", sortFilterObject);
  }

  changeSortingDirection() {
    console.log("sort-and-filer-bar - change sorting direction")
    if (this.sortDirection == 'ASC') {
      this.sortDirection = 'DESC';
    } else {
      this.sortDirection = 'ASC';
    }
    this.sortingChanged();
  }

  presentPopover(myEvent) {
    console.log("venue-filter-button - presenting popover!")

    let popoverProm = this.popoverCtrl.create({
      component: SelectorPopoverPage,
      componentProps: {items: this.sortFilters, selectedItem: this.sortFilter},
      event: myEvent
    });
    popoverProm.then((popover) => popover.present());
  }
}
